import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class CustomValidators {
  
  // Custom Validator for Email or Phone (already discussed)
  static emailOrPhoneValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null; // Don't validate if value is empty
      }

      let value = control.value;
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const phoneRegex = /^[0-9]{10}$/;
      value = value.replace(/ /g, ''); // Remove spaces
      if (emailRegex.test(value) || phoneRegex.test(value)) {
        return null; // Valid
      }

      return { invalidUsername: true }; // Invalid
    };
  }

  // Password Validator: Must be at least 8 characters long and contain at least one number, one special character, and one uppercase letter
  static passwordValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null; // Don't validate if value is empty
      }

      const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{1,30}$/;
      
      if (passwordRegex.test(control.value)) {
        return null; // Valid
      }
      return { invalidPassword: true }; // Invalid
    };
  }

  // Phone Number Validator: Only allows exactly 10 digits
  static phoneNumberValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null; // Don't validate if value is empty
      }

      const phoneRegex = /^[0-9]{10}$/;

      if (phoneRegex.test(control.value)) {
        return null; // Valid
      }
      return { invalidPhoneNumber: true }; // Invalid
    };
  }

  // Text Validator: Only allows alphabetic characters and spaces
  static textValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null; // Don't validate if value is empty
      }

      const textRegex = /^[a-zA-Z\s]+$/;

      if (textRegex.test(control.value)) {
        return null; // Valid
      }
      return { invalidText: true }; // Invalid
    };
  }

  // Integer Validator: Only allows integer values (positive or negative)
  static intValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null; // Don't validate if value is empty
      }

      const intRegex = /^-?\d+$/;

      if (intRegex.test(control.value)) {
        return null; // Valid
      }
      return { invalidInteger: true }; // Invalid
    };
  }
}
